$(function(){
          const height="150px";
            // $('.read-more').click(function() {
            //   var This = $(this).parent();
            //   // var reducedHeight = $(this).height();
            //   // $(this).css('height', 'auto');
            //   // var fullHeight = $(this).height();
            //   // $(this).height(reducedHeight);
            //   This.animate({height: "300px"}, 500);
            //   This.mouseout(function() {
            //   console.log(0);
            //   $(this).css('color', '#898989');
            //   $(this).animate({height: height}, 500);
            //   });
            //   // $(this).css('color', '#282827');
            // });
            
            
        });